import { c as _c } from "react/compiler-runtime";
import { HotelReservedCardContentPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-content/hotel-reserved-card-content.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import isEmpty from "lodash-es/isEmpty";
import { FC } from "react";
export const HotelReserveCardFullCapacity: FC<Pick<HotelReservedCardContentPropertiesType, "onClick" | "id" | "notifyData" | "roomCount">> = properties => {
  const $ = _c(38);
  const {
    onClick,
    id,
    notifyData,
    roomCount
  } = properties;
  const t0 = `flex flex-col items-center gap-4 p-4 lg:max-h-[64px] lg:flex-row lg:gap-6 ${isEmpty(notifyData) ? "justify-end" : "justify-between"}`;
  let t1;
  if ($[0] !== id || $[1] !== notifyData) {
    t1 = !isEmpty(notifyData) && <Button StartIcon={notifyData?.isSubmitted ? <MaterialIcon name="check" /> : <MaterialIcon name="notifications_active" variant="outlined" />} className="order-3 w-full md:order-1 lg:w-[170px]" color={notifyData?.isSubmitted ? "neutral" : "secondary"} loading={notifyData?.isSubmitted && notifyData?.isLoading} onClick={() => notifyData?.onclick(Number(id), notifyData?.isSubmitted)} size="small" variant="outline">موجود شد خبرم کن</Button>;
    $[0] = id;
    $[1] = notifyData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-on-surface-high-emphasis text-caption">بررسی وضعیت موجودی اتاق از روی تقویم</div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== id || $[5] !== onClick || $[6] !== roomCount) {
    t3 = <div className="order-2 flex flex-col items-center justify-between gap-4 lg:flex-row lg:gap-6">{t2}<Button className="order-1 w-full md:order-3 lg:w-[118px]" color="secondary" onClick={() => onClick ? onClick({
        roomId: id,
        tabSelected: "roomCalendar",
        noRooms: roomCount
      }) : undefined} size="small" variant="text">تقویم موجودی</Button></div>;
    $[4] = id;
    $[5] = onClick;
    $[6] = roomCount;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = Boolean(notifyData?.isOpenModal);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-row gap-4"><MaterialIcon className="text-on-surface-medium-emphasis text-headline-5" name="notifications_active" variant="outlined" /><span className="text-headline-6">موجود شد خبرم کن</span></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = notifyData?.onCloseModal;
  let t7;
  if ($[9] !== t6) {
    t7 = <div className="flex flex-row justify-between">{t5}<MaterialIcon className="cursor-pointer" name="close" onClick={t6} /></div>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `${notifyData?.isLimited ? "flex-auto" : ""} text-body-2`;
  let t9;
  if ($[11] !== notifyData?.isLimited) {
    t9 = notifyData?.isLimited ? <div><div>تعداد درخواست‌های فعال شما به سقف مجاز رسیده است.</div><div>پس از مشخص شدن وضعیت یکی از آن‌ها، می‌توانید مجدداً درخواست ثبت کنید.</div></div> : "\u062F\u0631 \u0635\u0648\u0631\u062A \u0645\u0648\u062C\u0648\u062F \u0634\u062F\u0646 \u0627\u06CC\u0646 \u0627\u062A\u0627\u0642\u060C \u0627\u0632 \u0637\u0631\u06CC\u0642 \u067E\u06CC\u0627\u0645\u06A9 \u0628\u0647 \u0634\u0645\u0627 \u0627\u0637\u0644\u0627\u0639 \u062E\u0648\u0627\u0647\u06CC\u0645 \u062F\u0627\u062F.";
    $[11] = notifyData?.isLimited;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== notifyData?.isLimited) {
    t11 = !notifyData?.isLimited && <div className="text-caption text-on-surface-medium-emphasis flex-auto">توجه: شما می‌توانید حداکثر برای ۱۵ درخواست اطلاع‌رسانی ثبت کنید.</div>;
    $[16] = notifyData?.isLimited;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = notifyData?.isLoading;
  let t13;
  if ($[18] !== id || $[19] !== notifyData) {
    t13 = () => notifyData?.onclick(Number(id), notifyData?.isSubmitted);
    $[18] = id;
    $[19] = notifyData;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = notifyData?.isLimited ? "\u0645\u062A\u0648\u062C\u0647 \u0634\u062F\u0645" : "\u062E\u0628\u0631\u0645 \u06A9\u0646";
  let t15;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
    t15 = <Button color="secondary" loading={t12} onClick={t13} text={t14} />;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t15 || $[28] !== t7) {
    t16 = <div className="flex h-full flex-col gap-6">{t7}{t10}{t11}{t15}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t15;
    $[28] = t7;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16 || $[31] !== t4) {
    t17 = <Modal className="!z-20" mobileHeight="auto" open={t4}>{t16}</Modal>;
    $[30] = t16;
    $[31] = t4;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t0 || $[34] !== t1 || $[35] !== t17 || $[36] !== t3) {
    t18 = <div className={t0}>{t1}{t3}{t17}</div>;
    $[33] = t0;
    $[34] = t1;
    $[35] = t17;
    $[36] = t3;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  return t18;
};